import React from 'react';
import { Link } from 'react-router-dom';

import useRecentCategories from '../hooks/useRecentCategories';
import useProducts from '../hooks/useProducts';
import ProductCard from '../components/product/ProductCard';
import Card from '../components/ui/Card';
import { categorySwatch } from '../utils/categorySwatch';
import backgroundImage from '../images/background.png';

// Value-proposition cards (verbatim from the original site's landing page).
const VALUE_CARDS = [
  {
    title: 'What We Sell',
    body: 'We believe in selling handcrafted, natural products, uniquely made with care and a strong attention to detail.',
  },
  {
    title: "Why It's Sustainable",
    body: 'Every item uses ethically sourced, high-quality organic ingredients. Most are grown or foraged in Montana, while others are only sourced from eco-friendly businesses across the U.S.',
  },
  {
    title: 'Why It Matters',
    body: 'Your purchase supports local communities, reduces waste, and helps create a more sustainable future.',
  },
];

export default function Home() {
  const { categories } = useRecentCategories(4);
  const { items: featured } = useProducts({ limit: 4, sort: 'newest' });

  return (
    <>
      {/* hero — background image spans from the bottom of the header down to
          just above the value cards */}
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <section className="ss-container" style={{ paddingBlock: 'var(--ss-space-8)' }}>
          <Card style={{ maxWidth: 820 }}>
            <h1 style={{ fontSize: '2.75rem' }}>Where Timeless Craft Meets Sustainable Beauty</h1>
            <p style={{ marginTop: 'var(--ss-space-4)', fontSize: '1.15rem' }}>
              Thoughtfully Made Eco-friendly Products — a woman-owned Montana small
              business.
            </p>
            <p style={{ marginTop: 'var(--ss-space-5)', display: 'flex', gap: 'var(--ss-space-3)', flexWrap: 'wrap' }}>
              <Link className="ss-btn ss-btn--primary" to="/products">Shop all products</Link>
            </p>
          </Card>
        </section>
      </div>

      {/* value proposition */}
      <section className="ss-container ss-section">
        <div className="ss-feature-grid">
          {VALUE_CARDS.map((c) => (
            <div key={c.title} className="ss-feature-card">
              <h3>{c.title}</h3>
              <p>{c.body}</p>
            </div>
          ))}
        </div>
      </section>

      {/* category tiles */}
      {categories.length > 0 && (
        <section className="ss-container ss-section">
          <div className="ss-section__head">
            <div>
              <h2>Freshly Sprouted</h2>
              <p className="ss-section__sub">Categories we’ve just restocked and refreshed</p>
            </div>
            <Link to="/products">Shop all</Link>
          </div>
          <div className="ss-cat-tiles">
            {categories.map((c, i) => (
              <Link
                key={c._id || c.id}
                to={`/category/${c.slug}`}
                className="ss-cat-tile"
                style={{ background: categorySwatch(c.displayOrder ? c.displayOrder - 1 : i) }}
              >
                {c.name}
              </Link>
            ))}
          </div>
        </section>
      )}

      {/* featured products */}
      {featured.length > 0 && (
        <section className="ss-container ss-section">
          <div className="ss-section__head">
            <div>
              <h2>Just Picked</h2>
              <p className="ss-section__sub">Our newest products, fresh off the bench</p>
            </div>
            <Link to="/products?sort=newest">See more</Link>
          </div>
          <div className="ss-product-grid">
            {featured.map((p) => (
              <ProductCard key={p._id || p.id} product={p} />
            ))}
          </div>
        </section>
      )}
    </>
  );
}
